export default function (shipmentType, actualShipmentType) {
  if (shipmentType !== actualShipmentType) {
    return `${shipmentType} (${actualShipmentType})`
  }

  return shipmentType
}
